import config from 'config';

import React from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// MUI
import { Typography } from '@mui/material';
// styles
import classes from './styles.module.scss';

const Footer:React.FC = () => {
  const { t } = useTranslation('common');
  const { phoneNumber, adressLabel, adressLink } = config;

  return (
    <footer className={classes.footer}>
      <div className={[classes.footerContent, 'container'].join(' ')}>
        <address className={classes.address}>
          <Typography component="p" sx={{ fontSize: '18px', color: '#0e073c', fontWeight: 600 }}>Termo Clinic</Typography>
          <a href={adressLink} target="_blank" rel="noreferrer">{adressLabel}</a>
          <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`}>{phoneNumber}</a>
          <a href="mailto:termoclinic@gmail.com">termoclinic@gmail.com</a>
          <span>{t('homePage.area.hours')}</span>
        </address>
        <Typography sx={{ fontSize: '16px', color: '#696393' }}>{`© ${new Date().getFullYear()} Termo Clinic`}</Typography>
      </div>
    </footer>
  );
}

export default Footer;
